import LoadingSpinner from 'components/Shared/LoadingSpinner';
import { colors, screen } from 'components/styles/variables';

function LoadingImage(): JSX.Element {
  return (
    <>
      <div className="gray-background">
        <LoadingSpinner containerSize={64} spinnerSize={36} isWhite={false} />
      </div>
      <style jsx>
        {`
        .gray-background {
          position: absolute;
          left: 0;
          background-color: ${colors.G2};
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 16px;
          width: 100%;
          height: 157px;
          background-position: 0px 0px;
        }

        @media (min-width: ${screen.smMin}) {
          .gray-background {
            height: 326px;
          }
      `}
      </style>
    </>
  );
}

export default LoadingImage;
